import { _axios } from '@/plugins/axios';
import { IUserProfile } from '@/shared/models';

export default {
  async getListUser(): Promise<IUserProfile[]> {
    try {
      const users = await _axios.get('/manage/user');
      return users.data;
    } catch (e) {
      throw e;
    }
  },
  async getUser(id: any): Promise<IUserProfile> {
    try {
      const user = await _axios.get(`/manage/user/${id}`);
      return user.data;
    } catch (e) {
      throw e;
    }
  },
  async updateUser(id: any, user: IUserProfile): Promise<void> {
    try {
      await _axios.put(`/manage/user/${id}`, user);
    } catch (e) {
      throw e;
    }
  },
};
